module.exports = __webpack_public_path__ + "img/conde2.ddf242d6.jpg";